import React, { useState } from 'react';
import { 
  UserPlus, X, ArrowRight, ArrowLeft, 
  Mail, User, Phone, MapPin, Calendar, 
  FileText
} from 'lucide-react';
import axios from 'axios';
import Select from 'react-select';

const roles = [
  { "name": "SuperAdmin" },  // This role has access to all tools
  { "name": "SecAdmin" },     // This role can access specific tools
  { "name": "SSOAdmin" },     // This role can access specific tools
  { "name": "BackupAdmin" },  // Specific roles
  { "name": "CryptoAdmin" },   // Specific roles
  { "name": "DPO" },          // No specific tools mentioned
  { "name": "EduconnectAdmin" }, // No specific tools mentioned
  { "name": "FinAdmin" },     // No specific tools mentioned
  { "name": "HashAdmin" },    // No specific tools mentioned
  { "name": "HelpDesk" },     // No specific tools mentioned
  { "name": "IsrisAdmin" },   // No specific tools mentioned
  { "name": "MobileAnalyst" },// No specific tools mentioned
  { "name": "NetAdmin" },     // No specific tools mentioned
  { "name": "PhishingAnalyst" }, // No specific tools mentioned
  { "name": "TreatEyeAdmin" }, // No specific tools mentioned
  { "name": "WAFAdmin" },     // No specific tools mentioned
  { "name": "User" },         // Regular user access
  { "name": "Guest" },        // Limited access
];

const tools = [
  { "name": "Backup" },       // Accessible only by SecAdmin and SSOAdmin
  { "name": "CognitoNet" },   // Accessible by User and Guest
  { "name": "crypto" },       // Accessible by User and Guest
  { "name": "Educonnect" },   // Accessible by User and Guest
  { "name": "Phishing" },      // Accessible by User and Guest
  { "name": "SecDEL" },       // Accessible only by SuperAdmin and SecDELAdmin
  { "name": "SSOPanel" },     // Accessible only by SecAdmin and SSOAdmin
  { "name": "TraceMaster" },  // Accessible by User and Guest
  { "name": "VScanner" },     // Accessible by User and Guest
  { "name": "hashing" },      // Accessible by User and Guest
  { "name": "landing" },      // Accessible by User and Guest
 
];

// This example assumes you have a way to check permissions when using tools.


const AddUserModal = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    first_name: '',
    last_name: '',
    role: '',
    tools: [],
    phone_number: '',
    date_of_birth: '',
    address: '',
    bio: '',
    preferences: {
      notifications: true,
      twoFactorAuth: false
    }
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);

  const validateStep = (stepNumber) => {
    const newErrors = {};
    
    switch (stepNumber) {
      case 1:
        if (!formData.first_name) newErrors.first_name = 'First name is required';
        if (!formData.last_name) newErrors.last_name = 'Last name is required';
        if (!formData.phone_number) newErrors.phone_number = 'Phone number is required';
        if (!formData.date_of_birth) newErrors.date_of_birth = 'Date of birth is required';
        break;

      case 2:
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) {
          newErrors.email = 'Invalid email format';
        }
        if (!formData.password) newErrors.password = 'Password is required';
        else if (formData.password.length < 8) {
          newErrors.password = 'Password must be at least 8 characters';
        }
        if (formData.password !== formData.confirmPassword) {
          newErrors.confirmPassword = 'Passwords do not match';
        }

        // Validate role selection
        if (!formData.role) newErrors.role = 'Role selection is required';

        // Validate tool selection
        if (formData.tools.length === 0) newErrors.tools = 'At least one tool must be selected';
        break;

      case 3:
        if (!formData.address) newErrors.address = 'Address is required';
        break;
    }
    
    setErrors(newErrors); // Update the errors state with the new errors
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
};

     // Handler to manage tool selection
     const handleToolChange = (selectedOptions) => {
      setFormData((prevState) => ({
          ...prevState,
          tools: selectedOptions.map(option => option.value), // Store only values
      }));
  };


  const handleNext = () => {
    if (validateStep(step)) {
      setStep(step + 1);
    }
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    
    // Validate the current step before proceeding
    if (validateStep(step)) {
        setIsSubmitting(true); // Set submission state to true to show loading feedback
        try {
            // Prepare and send form data to the backend, including role and tools
            const response = await axios.post('/api/sso/register', {
                email: formData.email,
                password: formData.password,
                confirmPassword: formData.confirmPassword,
                first_name: formData.first_name,
                last_name: formData.last_name,
                phone_number: formData.phone_number,
                date_of_birth: formData.date_of_birth,
                address: formData.address,
                bio: formData.bio,
                preferences: formData.preferences,
                role: formData.role,  // Added role
                tools: formData.tools, // Added tools
            });

          
              // Handle successful registration response
              setSubmitMessage({ type: 'success', msg: response.data.msg });
              //alert(response.data.msg); // Optional alert to the user
              
              // Reset form data to initial state after successful registration
              setFormData({
                  email: '',
                  password: '',
                  confirmPassword: '',
                  first_name: '',
                  last_name: '',
                  phone_number: '',
                  date_of_birth: '',
                  address: '',
                  bio: '',
                  preferences: {
                      notifications: true, // Default preferences
                      twoFactorAuth: false
                  },
                  role: '',      // Reset role field
                  tools: [],     // Reset tools f*/ield (assuming it's an array)
              });
 
              setTimeout(() => {
                onClose(); // Close the registration modal or modal
                setStep(1); // Reset the step to 1  
                setSubmitMessage(null); // Clear any existing submission message
              }, 5000)         
        } catch (error) {
            // Handle any errors that occur during registration
            //console.log(error.response);
            if (error.response && error.response.data) {
                setSubmitMessage({ type: 'error', msg: error.response.data.error || 'An unexpected error occurred. Please try again.' });
                setTimeout(() => {
                  setSubmitMessage({});
                }, 5000);
            } else {
                setSubmitMessage({ type: 'error', msg: 'Registration failed. Please try again.' });
                setTimeout(() => {
                  setSubmitMessage({});
                }, 5000);
            }
        } finally {
            setIsSubmitting(false); // Reset submission state
        }
    }
};
  

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  if (!isOpen) return null;

  // Custom styles for react-select
  const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: '#1f2937', // Dark background
        borderColor: '#4b5563', // Dark border
        color: 'white', // Text color
        '&:hover': {
            borderColor: '#3b82f6', // Change border color on hover
        },
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#4b5563' : '#1f2937', // Background colors
        color: state.isSelected ? 'white' : 'white', // Text colors
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#3b82f6', // Color for selected values
        color: 'white',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'white', // Text color for selected values
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'white', // Remove color
        ':hover': {
            backgroundColor: '#ef4444', // Remove background color on hover
            color: 'white', // Change text color on hover
        },
    }),
};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg max-w-2xl w-full mx-4">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-700">
          <h3 className="text-xl font-semibold text-gray-100">Add New User</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-300"
          >
            <X size={24} />
          </button>
        </div>

        {/* Progress Indicator */}
        <div className="px-6 pt-4">
          <div className="flex justify-between mb-4">
            {['Personal', 'Account', 'Additional'].map((label, index) => (
              <div key={label} className="flex items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center
                  ${step > index + 1 ? 'bg-green-600' : 
                    step === index + 1 ? 'bg-blue-600' : 'bg-gray-600'}`}>
                  {step > index + 1 ? '✓' : index + 1}
                </div>
                <div className="ml-2 text-sm text-gray-400">{label}</div>
                {index < 2 && (
                  <div className={`h-1 w-12 mx-2 ${
                    step > index + 1 ? 'bg-green-600' : 'bg-gray-600'
                  }`} />
                )}
              </div>
            ))}
          </div>
        </div>

          {/* Error or Success Message */}
          {submitMessage && (
            <div className={`mt-4 p-3 flex justify-center ${submitMessage.type === 'success' ? 'bg-green-900 text-green-300' : 'bg-red-900 text-red-300'} rounded-md`}>
              {submitMessage.msg}
            </div>
          )}
        {/* Form Content */}
        <form onSubmit={handleSubmit} className="p-6">
          {step === 1 && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-1">
                    First Name*
                  </label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                    <input
                      type="text"
                      name="first_name"
                      required
                      value={formData.first_name}
                      onChange={handleInputChange}
                      className={`w-full pl-10 pr-4 py-2 bg-gray-700 border ${
                        errors.first_name ? 'border-red-500' : 'border-gray-600'
                      } rounded-md text-white focus:outline-none focus:border-blue-500`}
                    />
                  </div>
                  {errors.first_name && (
                    <p className="mt-1 text-sm text-red-500">{errors.first_name}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-1">
                    Last Name*
                  </label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                    <input
                      type="text"
                      name="last_name"
                      required
                      value={formData.last_name}
                      onChange={handleInputChange}
                      className={`w-full pl-10 pr-4 py-2 bg-gray-700 border ${
                        errors.last_name ? 'border-red-500' : 'border-gray-600'
                      } rounded-md text-white focus:outline-none focus:border-blue-500`}
                    />
                  </div>
                  {errors.last_name && (
                    <p className="mt-1 text-sm text-red-500">{errors.last_name}</p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Phone Number*
                </label>
                <div className="relative">
                  <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="tel"
                    name="phone_number"
                    value={formData.phone_number}
                    autoComplete='off'
                    required
                    onChange={handleInputChange}
                    className={`w-full pl-10 pr-4 py-2 bg-gray-700 border ${
                      errors.phone_number ? 'border-red-500' : 'border-gray-600'
                    } rounded-md text-white focus:outline-none focus:border-blue-500`}
                  />
                </div>
                {errors.phone_number && (
                  <p className="mt-1 text-sm text-red-500">{errors.phone_number}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Date of Birth*
                </label>
                <div className="relative">
                  <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="date"
                    name="date_of_birth"
                    value={formData.date_of_birth}
                    onChange={handleInputChange}
                    className={`w-full pl-10 pr-4 py-2 bg-gray-700 border ${
                      errors.date_of_birth ? 'border-red-500' : 'border-gray-600'
                    } rounded-md text-white focus:outline-none focus:border-blue-500`}
                  />
                </div>
                {errors.date_of_birth && (
                  <p className="mt-1 text-sm text-red-500">{errors.date_of_birth}</p>
                )}
              </div>
            </div>
          )}

          {step === 2 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Email Address */}
                <div>
                    <label className="block text-sm font-medium text-gray-300 mb-1">
                        Email Address*
                    </label>
                    <div className="relative">
                        <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                        <input
                            type="email"
                            name="email"
                            required
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full pl-10 pr-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:border-blue-500"
                            placeholder="user@example.com"
                        />
                    </div>
                    {errors.email && (
                    <p className="mt-1 text-sm text-red-500">{errors.email}</p>
                  )}
                </div>

                {/* Password */}
                <div>
                    <label className="block text-sm font-medium text-gray-300 mb-1">
                        Password*
                    </label>
                    <input
                        type="password"
                        required
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:border-blue-500"
                    />
                    {errors.password && (
                    <p className="mt-1 text-sm text-red-500">{errors.password}</p>
                  )}
                </div>

                {/* Confirm Password */}
                <div>
                    <label className="block text-sm font-medium text-gray-300 mb-1">
                        Confirm Password*
                    </label>
                    <input
                        type="password"
                        name="confirmPassword"
                        required
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:border-blue-500"
                    />
                    {errors.confirmPassword && (
                    <p className="mt-1 text-sm text-red-500">{errors.confirmPassword}</p>
                  )}
                </div>

                {/* Role Selection */}
                <div>
                    <label className="block text-sm font-medium text-gray-300 mb-1">
                        Role*
                    </label>
                    <select
                        name="role"
                        value={formData.role}
                        required
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:border-blue-500"
                    >
                        <option value="">Select a role</option>
                        {roles.map((role) => (
                            <option key={role.name} value={role.name}>
                                {role.name}
                            </option>
                        ))}
                    </select>
                    {errors.role && (
                    <p className="mt-1 text-sm text-red-500">{errors.role}</p>
                  )}
                </div>

                {/* Multi-Select Tools Dropdown */}
                <div className="col-span-2"> {/* Span across both columns for better layout */}
                    <label className="block text-sm font-medium text-gray-300 mb-1">
                        Tools*
                    </label>
                    <Select
                        isMulti
                        options={tools.map(tool => ({ value: tool.name, label: tool.name }))} // Adjusted options format
                        className="text-black"
                        required
                        styles={customSelectStyles} // Apply custom styles
                        onChange={handleToolChange}
                    />
                    {/* For tools */}
                      {errors.tools && (
                          <p className="mt-1 text-sm text-red-500">{errors.tools}</p>
                      )}
                </div>

            </div>
            )}

          {step === 3 && (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Address*
                </label>
                <div className="relative">
                  <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    autoComplete='off'
                    onChange={handleInputChange}
                    className={`w-full pl-10 pr-4 py-2 bg-gray-700 border ${
                      errors.address ? 'border-red-500' : 'border-gray-600'
                    } rounded-md text-white focus:outline-none focus:border-blue-500`}
                  />
                </div>
                {errors.address && (
                  <p className="mt-1 text-sm text-red-500">{errors.address}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Bio
                </label>
                <div className="relative">
                  <FileText className="absolute left-3 top-3 text-gray-400" size={20} />
                  <textarea
                    name="bio"
                    value={formData.bio}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full pl-10 pr-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:border-blue-500"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Preferences
                </label>
                <div className="space-y-2">
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="notifications"
                      checked={formData.preferences.notifications}
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        preferences: {
                          ...prev.preferences,
                          notifications: e.target.checked
                        }
                      }))}
                      className="form-checkbox h-4 w-4 text-blue-600 bg-gray-700 border-gray-600 rounded"
                    />
                    <span className="text-gray-300">Enable notifications</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name="twoFactorAuth"
                      checked={formData.preferences.twoFactorAuth}
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        preferences: {
                          ...prev.preferences,
                          twoFactorAuth: e.target.checked
                        }
                      }))}
                      className="form-checkbox h-4 w-4 text-blue-600 bg-gray-700 border-gray-600 rounded"
                    />
                    <span className="text-gray-300">Enable two-factor authentication</span>
                  </label>
                </div>
              </div>
            </div>
          )}

        

          {/* Form Actions */}
          <div className="mt-6 flex justify-between">
            {step > 1 && (
              <button
                type="button"
                onClick={handlePrevious}
                className="px-4 py-2 bg-gray-700 text-white rounded-md flex items-center gap-2"
              >
                <ArrowLeft size={20} />
                Previous
              </button>
            )}
            {step < 3 ? (
              <button
                type="button"
                onClick={handleNext}
                className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center gap-2"
              >
                Next 
                <ArrowRight size={20} />
              </button>
            ) : (
              <button
                disabled={isSubmitting}
                type="submit"
                className={`px-4 py-2 bg-${isSubmitting ? 'blue-900' : 'blue-600'} text-white rounded-md flex items-center gap-2`}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
